import React from 'react';
import { Box, Input, Text, VStack } from '@chakra-ui/react';
import { ff } from '../theme';

export type MissingHandleKey = 'instagramHandle' | 'tiktokHandle';

export const MISSING_HANDLE_LABELS: Record<MissingHandleKey, string> = {
  instagramHandle: 'Instagram',
  tiktokHandle: 'TikTok',
};

interface MissingHandleInputsProps {
  missing: MissingHandleKey[];
  values: Record<MissingHandleKey, string>;
  onChange: (key: MissingHandleKey, value: string) => void;
}

/**
 * Required handle inputs shown when the creator proposes deliverables on a
 * platform their profile has no handle for (see getMissingDeliverableHandles).
 */
const MissingHandleInputs: React.FC<MissingHandleInputsProps> = ({ missing, values, onChange }) => {
  if (missing.length === 0) return null;
  return (
    <VStack spacing={4} align="stretch">
      {missing.map((key) => (
        <Box key={key}>
          <Text fontWeight="600" fontSize="16px" color={ff.ink} mb={1}>
            {MISSING_HANDLE_LABELS[key]} handle <Text as="span" color={ff.danger}>*</Text>
          </Text>
          <Text fontSize="14px" color={ff.text2} mb={2} lineHeight="1.45">
            You&apos;re proposing {MISSING_HANDLE_LABELS[key]} content, but your profile doesn&apos;t
            have a {MISSING_HANDLE_LABELS[key]} account yet. Add your handle to continue.
          </Text>
          <Input
            value={values[key]}
            onChange={(e) => onChange(key, e.target.value)}
            placeholder="@yourhandle"
          />
        </Box>
      ))}
    </VStack>
  );
};

export default MissingHandleInputs;
